import { IconProps } from "../../types/utils";

const Message = ({ color, dimension, ...props }: IconProps) => (
  <svg
    width={dimension || 32}
    height={dimension || 32}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M16.0021 5.33325C10.1224 5.33325 5.3377 9.79903 5.3377 15.2888C5.34415 17.2769 5.97572 19.2124 7.1436 20.8213C6.87705 21.4533 6.55221 22.0592 6.17308 22.6311L5.69674 23.3421C5.40712 23.7727 5.28413 24.2938 5.35108 24.8084C5.41803 25.3231 5.67021 25.7955 6.06026 26.1376C6.45031 26.4796 6.9517 26.6676 7.4707 26.6666C9.45542 26.6696 11.3873 26.0257 12.9735 24.832C13.9597 25.1065 14.9786 25.2452 16.0022 25.2444C21.8819 25.2444 26.6666 20.7786 26.6666 15.2889C26.6666 9.79903 21.8819 5.33332 16.0022 5.33332L16.0021 5.33325ZM16.0021 23.111C14.802 23.1118 13.6135 22.8762 12.5041 22.4176C11.1777 23.7692 9.36415 24.5314 7.47071 24.5331L7.94705 23.8221C8.64138 22.768 9.18685 21.6229 9.56798 20.4195C8.23245 19.0443 7.48086 17.2058 7.4707 15.2888C7.4707 10.9689 11.2921 7.46658 16.0022 7.46658C20.7124 7.46658 24.5338 10.9688 24.5338 15.2888C24.5338 19.6087 20.7124 23.111 16.0022 23.111H16.0021Z"
      fill={color || "#242424"}
    />
    <path
      d="M12.4428 15.2896C12.4428 15.8787 11.9652 16.3564 11.3763 16.3564C10.7874 16.3564 10.3098 15.8787 10.3098 15.2896C10.3098 14.7006 10.7874 14.2229 11.3763 14.2229C11.9652 14.2229 12.4428 14.7006 12.4428 15.2896Z"
      fill={color || "#242424"}
    />
    <path
      d="M21.6877 15.2896C21.6877 15.8787 21.2101 16.3564 20.6212 16.3564C20.0323 16.3564 19.5547 15.8787 19.5547 15.2896C19.5547 14.7006 20.0323 14.2229 20.6212 14.2229C21.2101 14.2229 21.6877 14.7006 21.6877 15.2896Z"
      fill={color || "#242424"}
    />
    <path
      d="M17.0651 15.2896C17.0651 15.8787 16.5876 16.3564 15.9986 16.3564C15.4097 16.3564 14.9321 15.8787 14.9321 15.2896C14.9321 14.7006 15.4097 14.2229 15.9986 14.2229C16.5876 14.2229 17.0651 14.7006 17.0651 15.2896Z"
      fill={color || "#242424"}
    />
  </svg>
);

export default Message;
